import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

export const couponsAll = createApi({
  reducerPath: 'couponsAll',
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getAllCouponsList: builder.query({
      query: (params) => ({
        url: '/coupons/all',
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useGetAllCouponsListQuery } = couponsAll;
